import { ContactForm } from './contact-form.comp';
import { renderCompAndReturnUnmount } from '../utils';
export function renderContactFormAndReturnUnmount(elem, props) {
    return renderCompAndReturnUnmount(elem, ContactForm, props);
}
//# sourceMappingURL=contact-form-renderer.js.map